// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Search from '../_raw/ui/icon_search.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Search);
